export function openingLoader() {

  const cookieExists = document.cookie.split('; ').some(row => row.startsWith('animationPlayed='));


  const element = document.querySelector('.farlo-ss-loader');
  
  if (!cookieExists && element) {

    element.classList.add('farlo-ss-loader--active');
    

    element.addEventListener('animationend', function() {

      const oneWeek = 60 * 60 * 24 * 7;
      document.cookie = "animationPlayed=true; path=/; max-age=" + oneWeek;
      document.body.classList.remove("show-preloader");

    });
  } else {
    document.body.classList.remove("show-preloader");
    element.classList.remove('farlo-ss-loader--active');
  }
}